import { Component, Injectable, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Observable } from 'rxjs';
import { AuthService } from 'src/app/services/auth/auth.service';
import { TelecomService } from 'src/app/services/telecom/telecom.service';
import { TimeService } from 'src/app/services/time/time.service';
import { environment } from 'src/environments/environment';
import { Guid } from 'guid-typescript';

@Injectable()
export class UniqueANIValidator {
  constructor( private snackbar: MatSnackBar) {}
  public onlyUniqueKeys(data: Array<any>, formatPhoneNumber): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {

// change this to ANI being the unique thing
      if (!control) {
        return null;
      }
      
      let key = control.value

      let isDuplicated = false;
      for(let i=0;i<data.length; i++){
          if(formatPhoneNumber(key) == formatPhoneNumber(data[i].phoneNumber) && data[i].enabled){
            isDuplicated = true; 
        }
      }
      
      //isDuplicated = data.includes((row) => { return key == row.name})
      if(isDuplicated){
        this.snackbar.open(`The ANI '${key}' is already in use.`, "Ok", {verticalPosition: 'bottom'})
        return { "onlyUnique": true};
      }
      return null;
    };
  }
}

@Component({
  selector: 'app-ani-config',
  templateUrl: './ani-config.component.html',
  styleUrls: ['./ani-config.component.css']
})
export class AniConfigComponent implements OnInit {

  constructor(private formBuilder:FormBuilder, private telecomService:TelecomService, private UniqueANIValidator:UniqueANIValidator, private timeService:TimeService, private auth:AuthService, private snackbar: MatSnackBar) { }
  
  data: Array<any> = [];
  filteredData = [];
  inactiveData = [];
  mainstreetData = [];
  creatingRow = false;
  rowSelected = -1;
  mainstreetTypes: Array<any> = [["MSPP", "mspp"], ["Prime", "prime"], ["Prime and MSPP", "both"]];
  currentUser: string = this.auth.currentUser;
  editable: boolean = true;

  formatAgentTypeFunction = (type) => {
    if(this.mainstreetTypes.length>0){
      return this.mainstreetTypes.find((typeKey) => {return typeKey[1] == type})[0];
    }
    return type
  }
  formatPhoneNumberFunction = (phoneNumber) => {
    return this.displayFormatPhoneNumber(phoneNumber);
  }

  mainstreetForm = this.formBuilder.group({
    mainstreetANI: new FormControl('', [Validators.required, Validators.pattern(/^(\+?\d{1,2})?\s?\(?(\d{3})\)?[\s.-]?(\d{3})[\s.-]?(\d{4})$/), this.UniqueANIValidator.onlyUniqueKeys(this.data, this.formatPhoneNumber)]),
    mainstreetName: new FormControl('', [Validators.required]),
    mainstreetAgentType: new FormControl('', [Validators.required]),
    mainstreetAgentEmail: new FormControl('', [Validators.required, Validators.pattern(/(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/)])
  });

  ngOnInit(): void {
    this.getANIData();
  }


  handleMainstreetButtonEvent(e: any){
    console.log(e);
    if(e.button == "create"){
      this.creatingRow = true;
      this.rowSelected = 0;
      return;
    }
    if(e.button == "edit"){
      this.mainstreetForm.get('mainstreetANI').clearValidators();
      for(let i=0;i<this.mainstreetData.length;i++){
        let row = this.mainstreetData[i]
        let rowKey = row.id;
        let itemKey = e.item.id;
        if(rowKey == itemKey){
          this.rowSelected = i;
          console.log(i)
          break;
        }
      }
    }
    if(e.button == "confirm" || e.button == "delete"){
      if(e.button == "confirm"){
        this.editable = false;
      }
      if(e.button == "confirm"){
        this.mainstreetData[this.rowSelected]["ani"] = this.formatPhoneNumber(e.item["ani"]);
        if (this.creatingRow){
          let now = new Date();
          let createdDate = this.timeService.getDateTimeString(now);
          e.item["creator"] = this.currentUser;
          e.item["createdDate"] = createdDate;
          e.item["id"] = this.GUID();
        }
        this.updateRow(e.item, this.mainstreetData);
      }
      let newData = this.mainstreetData[this.rowSelected];
      let operation = 'put';
      if(e.button == "delete"){
        operation = 'delete';
        newData = e.item;
      }
      let params = {
        FunctionName: environment.ANIConfigLambdaName,
        Payload: JSON.stringify({
          operation: operation,
          data: newData
        })
      };
      this.telecomService.callLambda(params, 'An error occurred while trying to save ANI configuration data: ').then((response: any) => {
        if(response.statusCode == 200){
          console.log(`response: ${response}`);
          //get data from response and syncronize local copy
          this.data = JSON.parse(response.body);
          console.log(`data updated: ${JSON.stringify(this.data)}`);
          this.getANIData();
        }else{
          console.error(response); 
          this.snackbar.open(`Error: ${JSON.stringify(response.Error)}`, "Ok", {verticalPosition: 'bottom'});
        }
      });
    }
    this.creatingRow = false;
  }

  filterData(){
    this.mainstreetData = this.data.filter((row) => {return (row.aniType == "MSPP")});
    this.mainstreetForm.get('mainstreetANI').setValidators([Validators.required, Validators.pattern(/^(\+?\d{1,2})?\s?\(?(\d{3})\)?[\s.-]?(\d{3})[\s.-]?(\d{4})$/), this.UniqueANIValidator.onlyUniqueKeys(this.data, this.formatPhoneNumber)]);
  }


  getANIData(){
    this.telecomService.getRows(environment.ANIConfigLambdaName).then((data: any) => {
      console.log(data)
      this.data = JSON.parse(data.body);
      this.filterData();
      this.editable = true;
      if(data.statusCode != 200){
        console.log("Error: ", data.Error)
      }
    });
  }

  updateRow(newrow, data){
    let now = new Date();
    let createdDate = this.timeService.getDateTimeString(now);
    newrow["updatedBy"] = this.currentUser;
    newrow["updatedDate"] = createdDate;
    let row = data.findIndex((row) => row.id == newrow.id);
    data[row] = newrow;
    return newrow
  }
  
  validateMainstreetPhoneNumber(phoneNumber){
    let formattedNumber = this.displayFormatPhoneNumber(phoneNumber);
    console.log(formattedNumber);
    this.mainstreetForm.patchValue({'mainstreetANI':formattedNumber});
  }

  displayFormatPhoneNumber(phoneNumber){
    //regex to format string
    let formattingRegex = /^(\+?\d{1,2}\s?)?(\d{3})(\d{3})(\d{4})$/;
    let matches = formattingRegex.exec(phoneNumber);
    let formattedNumber = phoneNumber;
    if (matches && matches.length >= 4){
      if(matches[1]){
        formattedNumber = `${matches[1]} (${matches[2]}) ${matches[3]}-${matches[4]}`;
      }
      else{
        formattedNumber = `(${matches[2]}) ${matches[3]}-${matches[4]}`;
      }
    }
    return formattedNumber;
  }


  formatPhoneNumber(phoneNumber){
    let formattedNumber = phoneNumber;
    let formattingRegex = /^(\+?\d{1,2})?\s?\(?(\d{3})\)?[\s.-]?(\d{3})[\s.-]?(\d{4})$/;
    let matches = formattingRegex.exec(phoneNumber);
    if (matches && matches.length >= 4){
      if(matches[1]){
        formattedNumber = `${matches[1]}${matches[2]}${matches[3]}${matches[4]}`;
      }
      else{
        formattedNumber = `+1${matches[2]}${matches[3]}${matches[4]}`;
      }
    }
    return formattedNumber
  }

  GUID(){
    return Guid.create()['value'];
  }
}
